import Dexie, { Table, liveQuery } from 'dexie';
import IAppS from 'dexie';
import { IAppStates } from './models/AppStates';
import { IAppUsers } from './models/AppUsers';
import { IJWT } from './models/JWT';
import { IDataSafe } from './models/DataSafe';
import { ISystemToDo } from './models/SystemToDo';
//import { IFHIRdsControl } from './models/FHIRdsControl';

//var db = new Dexie("FGAppDatabase");
//db.version(1).stores({appstates: 'id, isServerAuthenticated'});

export class FGAppDatabase extends Dexie {
    appstates!: Dexie.Table<IAppStates, number>;
    appusers!: Dexie.Table<IAppUsers, number>;
    jwt!: Dexie.Table<IJWT, number>;
    datasources!: Dexie.Table<IDataSources, number>;
    datasafe!: Dexie.Table<IDataSafe, number>;
    systemToDo!: Dexie.Table<ISystemToDo, number>;
    //FHIRdsControl!:Dexie.Table<IFHIRdsControl,number>;

    constructor() {  
      super("FGAppDatabase");
      //
      // Define tables and indexes
      // (Here's where the implicit table props are dynamically created)
      //
     // this.version(7).stores({
     //   appstates: '++id, isServerAuthenticated, appUser',
     //   appusers: '++id, name, password, sysId, dataBackend',
     //   datasources: '++id, HName, Connectortype',
     //   jwt: '++id, appUser_sysId, initialtoken, refreshtoken',
     //   datasafe: '++id, appUser, attribute, value, valueTSfrom, valueTSto, valueTSinsert, serverId, serverIdUpdateTS',
     //   systemToDo: '++id, appUser, what, with',
     //   FHIRdsControl: '++id, appUser, owner, external',
     // }); 

      this.version(6).stores({
        appstates: '++id, isServerAuthenticated, appUser',
        appusers: '++id, name, password, sysId, dataBackend',
        datasources: '++id, HName, Connectortype',
        jwt: '++id, appUser_sysId, initialtoken, refreshtoken',
        datasafe: '++id, appUser, attribute, value, valueTSfrom, valueTSto, valueTSinsert, serverId, serverIdUpdateTS',
        systemToDo: '++id, appUser, what, with',
      }); 

      this.version(5).stores({
        appstates: '++id, isServerAuthenticated, appUser',
        appusers: '++id, name, password, sysId',
        datasources: '++id, HName, Connectortype',
        jwt: '++id, appUser_sysId, initialtoken, refreshtoken',
        datasafe: '++id, appUser, attribute, value, valueTSfrom, valueTSto, valueTSinsert, serverId, serverIdUpdateTS',
        systemToDo: '++id, appUser, what, with',
      });      

      this.version(4).stores({
        appstates: '++id, isServerAuthenticated, appUser',
        appusers: '++id, name, password, sysId',
        datasources: '++id, HName, Connectortype',
        jwt: '++id, appUser_sysId, initialtoken, refreshtoken',
        datasafe: '++id, appUser, attribute, value, valueTSfrom, valueTSto, valueTSinsert, serverId',
      });

      this.version(3).stores({
        appstates: '++id, isServerAuthenticated, appUser',
        appusers: '++id, name, password, sysId',
        datasources: '++id, HName, Connectortype',
        jwt: '++id, appUser_sysId, initialtoken, refreshtoken',
        datasafe: '++id, *appUser, *attribute, value, *valueTSfrom, *valueTSto, valueTSinsert, serverId',
      });

      this.version(2).stores({
        appstates: '++id, isServerAuthenticated, appUser',
        appusers: '++id, name, password, sysId',
        datasources: '++id, HName, Connectortype',
        jwt: '++id, appUser_sysId, initialtoken, refreshtoken',
        datasafe: '++id, appUser, attribute, value, valueTSfrom, valueTSto, valueTSinsert, serverId',
      });

      this.version(1).stores({
        appstates: '++id, isServerAuthenticated, appUser',
        appusers: '++id, name, password, sysId',
        datasources: '++id, HName, Connectortype',
        jwt: '++id, appUser_sysId, initialtoken, refreshtoken',
      });
    }
}



export interface IDataSources {
    id?: number;
    hname: string;
    Connectortype: number;
}


export class DataSources implements IDataSources {
    id!: number;
    hname: string;
    Connectortype: number;

    constructor(hname: string, Connectortype: number, id?:number) {
        this.hname = hname;
        this.Connectortype = Connectortype;
        if (id) this.id = id;
    }
}

export const db = new FGAppDatabase();
